import React, { useState, useEffect } from "react";
import axios from "axios";
import useFormContext from "./GetEvent.jsx/useFormAdminContext";
import { useNavigate } from "react-router-dom";
import Modal from "./SendforOpenEventModal";
import ConfirmModal from '../components/ConfirmModal';
import { CANCEL_EVENT,EVENTS_BASE_URL } from './ApiDetails.js';
import { confirm } from "../utilities/Confirm.tsx";
import { confirmDelete } from "../utilities/ConfirmDelete.tsx";
import ReturnToRequestorModal from "./ReturnToRequestorModal.js";
import ConfirmationModalEventValidation from "./ConfirmationModalEventValidation.js";
export default function Footer({ setIsEditing, isEditing, handleSaveChanges }) {
  const {
    handleValidation,
    RejectEvent,
    SendToRequestor,
    ValidateOpenEvent,
    MarkAsComplete,
    eventFormData,
    setEventFormData,
    showModal,
    closeModal,
    showConfirmationModalEventValidation,
    setShowConfirmationModalEventValidation
  } = useFormContext();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReturnToRequestorModalOpen, setIsReturnToRequestorModalOpen] = useState(false);
  const navigate = useNavigate();
  const [
    isEventStatusPendingDocumentation,
    setIsEventStatusPendingDocumentation,
  ] = useState(false);

  useEffect(() => {
    if (eventFormData.eventStatus === "Pending documentation") {
      setIsEventStatusPendingDocumentation(true);
    }
  }, [eventFormData.eventStatus]);

  const navigateToApp = (role) => {
    // Role-based redirection
    switch (role) {
      case 'Visit Requester':
      case 'Requester':
        navigate('/AppRequester');
        break;
      case 'Admin':
        navigate('/AppAdmin');
        break;
      case 'Family':
        navigate('/AppFamily');
        break;
      case 'MLTUser':
        navigate('/AppMltEvent');
        break;
      case 'FamilyCoordinator':
        navigate('/AppFamily');
        break;
      case 'MLTCoordinator':
        navigate('/AppMltEvent');
        break;
      default:
        navigate('/');  // Redirect to home or login in case of an invalid role
        break;
    }
  }

  // Function to toggle edit mode and save changes if editing is true
  const handleEditClick = (e) => {
    e.preventDefault();

    // Prevent editing if the event is in "Completed" status
    if (eventFormData.eventStatus === "Completed") {
      alert("This event is completed and cannot be edited.");
      return; // Exit the function if the event is completed
    }

    if (!isEditing) {
      setIsEditing(true);
    }

    // If we're in edit mode, save the changes
    if (isEditing && handleValidation()) {
      handleSaveChanges();

      // Toggle the edit mode
      setIsEditing(false);
    }
  };

  const handleRejectClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Closes the modal
    navigateToApp(localStorage.getItem('role'));
  };

  const handleSaveClick = (comment) => {
    RejectEvent(comment);
    setIsModalOpen(false);
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    setIsModalOpen(false);
  };

  const handleConfirmValidationClick = (emailNotif) => {
    setShowConfirmationModalEventValidation(false);
    ValidateOpenEvent(emailNotif);
  };

  const handleSaveReturnToRequestorClick = (comment) => {
    setEventFormData(prevData => ({ ...prevData, eventStatus: "Draft" }));
    SendToRequestor(comment);
    setIsReturnToRequestorModalOpen(false);
    navigateToApp(localStorage.getItem('role'));
  };

  const handleCancelReturnToRequestorClick = (e) => {
    e.preventDefault();
    setIsReturnToRequestorModalOpen(false);
  };

  const handleDeleteEvent = async () => {
    const confirmResult = await confirmDelete({ title: 'Confirm', message: 'Are you sure you want to permanently delete this event?' });
    if (confirmResult) {
      try {
        const response = await axios.delete(`${EVENTS_BASE_URL}/${eventFormData.eventId}`);
        if (response.status === 200) {
          alert("Event has been deleted successfully.");
          navigateToApp(localStorage.getItem('role'));
        } else {
          console.error("Failed to delete the event. Response:", response);
          alert("Failed to delete the event. Please try again.");
        }
      } catch (error) {
        console.error("Error deleting the event:", error.response || error.message);
        alert(`An error occurred while deleting the event: ${error.response?.data || error.message}`);
      }
    }
  };

  const handleCancelEvent = async () => {
    const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to cancel this event?' });
    if (confirmResult) {
      try {
        const response = await axios.post(
          `${CANCEL_EVENT}/${eventFormData.eventId}`,
          {}, // An empty object as a placeholder for the request body if needed
          {
            headers: {
              'Content-Type': 'application/json', // Adjust if the API needs different headers
            },
          }
        );
        if (response.status === 200) {
          alert("Event has been canceled successfully.");
          navigateToApp(localStorage.getItem('role'));
        } else {
          console.error("Failed to cancel the event. Response:", response);
          alert("Failed to cancel the event. Please try again.");
        }
      } catch (error) {
        console.error("Error canceling the event:", error.response || error.message);
        alert(`An error occurred while canceling the event: ${error.response?.data || error.message}`);
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-outline-light left-button"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          {eventFormData.eventStatus !== 'Completed' ?
            (
              <div className="col-md-9 text-end">
                <button
                  id="editEvent"
                  className="btn btn-outline-light right-buttons"
                  onClick={handleEditClick}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="white"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21.7,4.3l-2-2c-0.4-0.4-1-0.4-1.4,0L8,12.6c-0.2,0.2-0.4,0.5-0.5,0.8L6,18c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.8,0.4,1.2,0.3 l4.6-1.5c0.3-0.1,0.6-0.3,0.8-0.5l10.3-10.3C22.1,5.3,22.1,4.7,21.7,4.3z M8.4,17.2L7.5,16.3l0.7-2.2l5.7-5.7l2,2L8.4,17.2z M18.3,7.3l-2-2l1-1l2,2L18.3,7.3z" />
                  </svg>
                  {isEditing ? "Save Changes" : "Edit Event"}
                  {/* Button text toggles */}
                </button>
                    <button type="button" id="deleteEvent" className="btn btn-outline-light right-buttons" onClick={handleDeleteEvent}
                    ><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="red" />
                        <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="red" />
                        <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="red" />
                    </svg>
                        DELETE EVENT
                    </button>
                {(eventFormData.eventStatus !== "Pending documentation") && (eventFormData.eventStatus !== 'Completed') && (eventFormData.eventStatus !== 'Rejected') && (eventFormData.eventStatus !== 'Cancelled') && (
                  <>
                    <button
                      type="button"
                      id="cancelEvent"
                      className="btn btn-outline-light right-buttons"
                      onClick={handleCancelEvent}
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="white" />
                        <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="white" />
                        <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="white" />
                      </svg>
                      CANCEL EVENT
                    </button>
                  </>
                )}
                {(eventFormData.eventStatus === "Under review") && (
                  <>
                    <button
                      type="button"
                      id="rejectEvent"
                      className="btn btn-outline-light right-buttons"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRejectClick();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="white"
                        viewBox="0 0 32 32"
                      >
                        <path d="M16 14.586l6.293-6.293a1 1 0 011.414 1.414L17.414 16l6.293 6.293a1 1 0 01-1.414 1.414L16 17.414l-6.293 6.293a1 1 0 01-1.414-1.414L14.586 16 8.293 9.707a1 1 0 111.414-1.414L16 14.586z" />
                      </svg>
                      REJECT EVENT REQUEST
                    </button>
                    <ConfirmModal
                      isOpen={isModalOpen}
                      onClose={handleModalClose}
                      onSave={handleSaveClick}
                      onCancel={handleCancelClick}
                    />
                    <button
                      type="button"
                      id="ReturnToRequestor"
                      className="btn btn-outline-light right-buttons"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsReturnToRequestorModalOpen(true);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M2.5,21.27L23.43,12L2.5,2.73V10l15,2l-15,2V21.27z"
                          transform="rotate(-45 12 12)"
                        ></path>
                      </svg>
                      RETURN TO THE REQUESTOR
                    </button>
                    <button
                      type="button"
                      id="ValidateOpen"
                      className="buttonrequest btn btn-outline-light right-buttons"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowConfirmationModalEventValidation(true);
                      }}
                    >
                      <svg
                        width="18"
                        height="12"
                        viewBox="0 0 18 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z"
                          fill="currentColor"
                        />
                      </svg>
                      VALIDATE AND OPEN EVENT
                    </button>
                  </>
                )}
                {isEventStatusPendingDocumentation && (
                  <button
                    type="button"
                    id="markAsComplete"
                    className="btn btn-outline-light right-buttons footerButtons"
                    onClick={(e) => {
                      e.preventDefault();
                      MarkAsComplete();
                    }}>
                    MARK AS COMPLETE
                  </button>
                )}
              </div>
            ) : (
              <div className="col-md-9 text-end">
                    <button type="button" id="deleteEvent" className="btn  btn-outline-light right-buttons" onClick={handleDeleteEvent}
                    ><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="red" />
                        <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="red" />
                        <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="red" />
                    </svg>
                        DELETE EVENT
                    </button>
              </div>
            )
          }
        </div>
      </div>
      <Modal show={showModal} handleClose={closeModal}>
        <p>Now Your Event has been Opened.</p>
      </Modal>
      <ReturnToRequestorModal
        isOpen={isReturnToRequestorModalOpen}
        onClose={() => setIsReturnToRequestorModalOpen(false)}
        onSave={(comment) => handleSaveReturnToRequestorClick(comment)}
        onCancel={handleCancelReturnToRequestorClick}
      />
      <ConfirmationModalEventValidation
        isOpen={showConfirmationModalEventValidation}
        onClose={() => setShowConfirmationModalEventValidation(false)}
        onSave={(emailNotif) => handleConfirmValidationClick(emailNotif)}
        onCancel={() => setShowConfirmationModalEventValidation(false)}
      />
    </footer>
  );
}
